import { render, staticRenderFns } from "./form-item-sites.vue?vue&type=template&id=189249af&"
import script from "./form-item-sites.vue?vue&type=script&lang=js&"
export * from "./form-item-sites.vue?vue&type=script&lang=js&"
import style0 from "./form-item-sites.vue?vue&type=style&index=0&id=189249af&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports